import DeleteTrendButton from "./DeleteTrendButton";

export default DeleteTrendButton;
